/**
 * @generated SignedSource<<9e7a7be1cc502e946b53941b0fc65e55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RunReportWithIntegrationInput = {
  integrationId: string;
  reportId: string;
};
export type useRunReportWithIntegrationMutation$variables = {
  input: RunReportWithIntegrationInput;
};
export type useRunReportWithIntegrationMutation$data = {
  readonly runReportWithIntegration: {
    readonly success: boolean | null;
  } | null;
};
export type useRunReportWithIntegrationMutation = {
  variables: useRunReportWithIntegrationMutation$variables;
  response: useRunReportWithIntegrationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RunReportWithIntegrationPayload",
    "kind": "LinkedField",
    "name": "runReportWithIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRunReportWithIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRunReportWithIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bee288ae3b8bdf24a3e0d83edb62ad53",
    "id": null,
    "metadata": {},
    "name": "useRunReportWithIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation useRunReportWithIntegrationMutation(\n  $input: RunReportWithIntegrationInput!\n) {\n  runReportWithIntegration(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f5100ca54a694b1902e8a893c86abb2";

export default node;
